import { LocationVarKey } from "@swivl-mono/types";

import { IS_NOT_EQUAL } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import { PageHeader, SwitchRow, TextAreaRow, TextRow } from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [LocationVarKey.FeatureWineStorage1, LocationVarKey.FeatureWineStorage2];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Wine Storage
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.FeatureWineStorage1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.FeatureWineStorage2}
        enableSwitchVar={LocationVarKey.FeatureWineStorage2Enabled}
      />
    </>
  );
}
